import DropdownController from "./dropdown_controller"

// Connects to data-controller="country-prefix"
// zeby to poprawnie dzialalo, trzeba dodac dwa ukryte pola w formularzu phoneInput i prefixInput, ktore beda wypelniane po wybraniu prefixu i numeru
export default class extends DropdownController {
  static targets = ["input", "prefix", "numberInput", "list", "prefixInput", "phoneInput", "emoji"]

  connect() {
    super.connect()
    this.element.addEventListener("client-modal:show-form", this.showForm.bind(this))
    this.setNumber()
    this.setPrefix()
  }

  select(e) {
    const li = e.target.closest("li")
    const prefix = `+${li.dataset.prefix}`
    const pickerEmoji = li.querySelector("#emoji")?.textContent?.trim() || ""

    this.prefixInputTarget.setAttribute("value", prefix)
    this.prefixTarget.dataset.value = prefix
    this.emojiTarget.textContent = pickerEmoji
    this.prefixTarget.textContent = prefix
  }

  fillInputs() {
    const prefix = this.prefixTarget.dataset.value
    const number = this.numberInputTarget.value

    this.prefixInputTarget.setAttribute("value", prefix)
    this.phoneInputTarget.setAttribute("value", number)
    console.log("full", prefix, number)
  }

  setNumber() {
    const number = this.phoneInputTarget.value
    if (number && number.length > 0) {
      this.numberInputTarget.value = number
    }
  }

  setPrefix() {
    const prefix = this.prefixTarget.dataset.value
    if (prefix) {
      this.prefixInputTarget.setAttribute("value", prefix)
    }
  }

  showForm(e) {
    const number = e.detail.phone
    const phonePrefix = e.detail.phonePrefix

    if (number && number.length > 0) {
      this.numberInputTarget.value = number
    }

    // ustaw prefix kraju jeśli został przekazany
    if (phonePrefix && phonePrefix.length > 0) {
      const prefixValue = phonePrefix.startsWith("+") ? phonePrefix : `+${phonePrefix}`
      const prefixNumber = prefixValue.replace("+", "")

      // znajdź element na liście krajów z pasującym prefixem
      const countryLi = this.listTarget.querySelector(`li[data-prefix="${prefixNumber}"]`)
      if (countryLi) {
        const emoji = countryLi.querySelector("#emoji")?.textContent?.trim() || ""
        this.emojiTarget.textContent = emoji
      }

      this.prefixInputTarget.setAttribute("value", prefixValue)
      this.prefixTarget.dataset.value = prefixValue
      this.prefixTarget.innerText = prefixValue
    }
  }
}
